<template>
  <div
    class="reference-uniform-list-subcategories-position"
    :class="{
      'reference-uniform-list-subcategories-childs': inSubcategory,
      'reference-uniform-list-subcategories-position-archive': type.isArchive,
      'reference-uniform-list-subcategories-position-active-hover': !type.isArchive,
    }"
  >
    <div class="reference-uniform-list-subcategories-position-content">
      <div class="reference-uniform-list-subcategories-position-name">
        {{ type.name }}
      </div>
      <div v-if="responsible" class="reference-uniform-list-subcategories-position-responsible">
        <a :href="`/index.php?r=redesign#/personal-employee/${responsible.id}/summary`" target="_blank">{{
          responsible.name
        }}</a>
      </div>
    </div>

    <div class="reference-uniform-list-subcategories-position-buttons">
      <c-button
        v-if="type.descriptionModel.hasDescription"
        class="reference-uniform-list-subcategories-position-buttons-comment"
        size="iconic"
        icon="comment"
        @click="$emit('showDescription')"
      />

      <type-actions
        class="reference-uniform-list-subcategories-position-buttons-menu"
        :type="type"
        @edit="$emit('edit')"
        @remove="$emit('remove')"
        @archiveOperation="$emit('archiveOperation')"
      />
    </div>
  </div>
</template>

<script>
import TypeActions from "./TypeActions";
import CButton from "@/components/controls2/Button";

export default {
  components: { TypeActions, CButton },
  props: ["type", "inSubcategory"],
  computed: {
    workersList() {
      return this.$store.getters["actors/workersList"].map((worker) => ({
        id: `${worker.value}`,
        name: worker.label,
      }));
    },
    responsible() {
      const { responsible } = this.type;
      if (!responsible) return null;
      const id = responsible.toString();
      return this.workersList.find((worker) => worker.id === id);
    },
  },
};
</script>

<style lang="scss" scoped>
.reference-uniform {
  &-list {
    &-subcategories {
      &-childs {
        width: calc(100% - 37px) !important;
        max-width: calc(100% - 37px) !important;
        margin-left: 37px !important;

        @media screen and (max-width: 700px) {
          width: calc(100% - 57px) !important;
          max-width: calc(100% - 57px) !important;
          margin-left: 57px !important;
        }
      }

      &-position {
        margin-left: 16px;
        width: calc(100% - 16px);
        max-width: calc(100% - 16px);
        display: flex;
        align-items: center;
        border: 1px solid #dfe4ef;
        position: relative;
        padding: 10px 15px;

        @media screen and (max-width: 700px) {
          width: calc(100% - 19px);
          max-width: calc(100% - 19px);
          margin-left: 19px;
          border-right: none;
        }

        &:after {
          content: "";
          position: absolute;
          top: -1px;
          left: -1px;
          height: 1px;
          background: #dfe4ef;
          width: 21px;
        }

        &-active-hover:hover {
          background: #e1edff !important;
        }

        &-archive {
          & .reference-uniform-list-subcategories-position-shelflife,
          & .reference-uniform-list-subcategories-position-name {
            opacity: 0.5;
          }
        }

        &-content {
          flex-grow: 1;
          overflow: hidden;
          display: flex;
          justify-content: space-between;
          align-items: center;

          @media screen and (max-width: 700px) {
            flex-direction: column;
            align-items: flex-start;
          }
        }

        &-name {
          flex-grow: 1;
          flex-shrink: 1;
          font-size: 13px;
          line-height: 108%;
          max-width: calc(100% - 104px);
          overflow-wrap: break-word;
        }

        &-responsible {
          font-size: 11px;
        }

        &-buttons {
          display: flex;
          align-items: center;
          justify-content: flex-end;
          margin-left: auto;
          min-width: 100px;
          padding-left: 15px;
          flex-shrink: 0;

          @media screen and (max-width: 700px) {
            min-width: 0;
          }

          &-comment {
            &::v-deep svg {
              max-width: 15px !important;
            }
          }

          &-menu {
            margin-left: 17px;

            &::v-deep .c-button-icon {
              margin-left: -7px !important;
            }
          }
        }
      }
    }
  }
}
</style>
